import { yupResolver } from '@hookform/resolvers/yup'
import React, { useContext } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'
import { SpinnerContext } from '../../../context/spinnerContext'
import { extendPropertySchedule } from '../../../redux/slices/propertySlice'
import { getISOToUTCDateFromTimestamp, getTimeStamp, getTimeZoneDifferenceMessage, objectsAreEqual } from '../../../helper/function'
import { extendCleningSchema } from '../../../util/validationSchema'
import { errorToast, successToast } from '../../../util/Toast/toast'
import CommonDateTimePicker from '../../commonDateTimePicker'
const ExtendCleningForm = ({ toggleExtendCleningModal, scheduleID, scheduledProperties, setIsRefresh, setCleaningScheduleRefersh }) => {
  const dispatch = useDispatch()
  const { changeLoader } = useContext(SpinnerContext)

  const updateDefualtValues = {
    next_checkout_time: scheduledProperties?.next_checkout_time && getISOToUTCDateFromTimestamp(scheduledProperties?.next_checkout_time),
    next_checkin_time: scheduledProperties?.next_checkin_time && getISOToUTCDateFromTimestamp(scheduledProperties?.next_checkin_time)
  }

  const methods = useForm({
    resolver: yupResolver(extendCleningSchema),
    mode: 'onBlur',
    defaultValues: updateDefualtValues
  })


  const {
    handleSubmit,
    control,
    trigger,
    watch,
    formState: { errors }
  } = methods
  
  const currentValue = watch()

  const hasChanged = objectsAreEqual(currentValue, updateDefualtValues) || Object.keys(errors)?.length !== 0

  const onSubmit = (data) => {
    setIsRefresh(false)
    const payload = {
      scheduleID: scheduleID,
      data: { next_checkin_time: getTimeStamp(data?.next_checkin_time), next_checkout_time: getTimeStamp(data?.next_checkout_time) }
    }
    if (scheduleID) {
      changeLoader(true)
      dispatch(extendPropertySchedule(payload))
        .then(({ payload }) => {
          if (payload?.status === 200) {
            changeLoader(false)
            // toggleMoreDetailModal()
            toggleExtendCleningModal()
            setIsRefresh(true)
            setCleaningScheduleRefersh && setCleaningScheduleRefersh(true)
            successToast(payload?.data?.status_message || 'Success!')
          } else {
            errorToast(payload?.data?.status_message || 'Something went wrong')
            changeLoader(false)
          }
        })

        .catch(() => {
          changeLoader(false)
        })
    }
  }

  return (
    <div>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="form-group">
            <div className="d-flex gap-2 align-item-center">
              <label className="form-control-label">Booking At</label>
            </div>
            <div className="custom_date_picker_w100">
              <CommonDateTimePicker
                name="next_checkout_time"
                control={control}
                placeholder="yyyy-MM-ddTHH:mm"
                onDateChange={() => {
                  trigger('next_checkout_time')
                }}
              />
            </div>
          </div>
          <div className="form-group mb-2">
            <label className="form-control-label">Checkin At</label>
            <div className="custom_date_picker_w100">
              <CommonDateTimePicker
                name="next_checkin_time"
                control={control}
                placeholder="yyyy-MM-ddTHH:mm"
                onDateChange={() => {
                  trigger('next_checkin_time')
                }}
                minDateTime={watch('next_checkout_time')}
              />
            </div>
          </div>
          <p
            className="fs-16 fw-400 red_color"
            dangerouslySetInnerHTML={{
              __html: getTimeZoneDifferenceMessage(scheduledProperties?.properties?.timezone)
            }}
          ></p>
          <div className="multi_btn_div mt-4">
            <button
              type="button"
              className="btn common-outline-btn w-100"
              onClick={() => {
                toggleExtendCleningModal()
              }}
            >
              Close
            </button>
            <button type="submit" className="btn btn-primary common-field-btn w-100" disabled={hasChanged}>
              Update
            </button>
          </div>
        </form>
      </FormProvider>
    </div>
  )
}

export default ExtendCleningForm
